export default "__VITE_ASSET__DxF87t$C__"